import { MinusIcon, PlusIcon } from '../../../icons/SvgIcons';

type ZoomContentProps = {
  zoom: number;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
  maxZoom?: number;
  minZoom?: number;
};

export const ZoomContent = ({
  zoom,
  setZoom,
  maxZoom = 200,
  minZoom = 50,
}: ZoomContentProps) => {
  const handleZoomIn = () => setZoom((zoom) => Math.min(zoom + 10, maxZoom)); // max 200%
  const handleZoomOut = () => setZoom((zoom) => Math.max(zoom - 10, minZoom)); // min 50%

  return (
    <div className="flex items-center gap-[9px] w-1/3 justify-center pt-1">
      <button
        id="zoom-content-zoom-out-button"
        data-testid="zoom-content-zoom-out-button"
        onClick={handleZoomOut}
      >
        <MinusIcon />
      </button>
      <span className="w-20 min-w-20 px-[17px] py-[9px] text-center text-sm text-gray-950 font-medium border border-gray-250v2">
        {zoom}%
      </span>
      <button
        id="zoom-content-zoom-in-button"
        data-testid="zoom-content-zoom-in-button"
        onClick={handleZoomIn}
      >
        {PlusIcon('#4E4E56')}
      </button>
    </div>
  );
};
